// components/LottieLoader.tsx
'use client';

import Lottie from 'lottie-react';
import { useEffect, useState } from 'react';

interface LottieLoaderProps {
  src: string; // путь, например: "/animations/sunny.json"
  className?: string;
}

export default function LottieLoader({ src, className }: LottieLoaderProps) {
  // ИСПРАВЛЕНО: Заменили any на unknown, так как структура JSON анимации сложная и валидируется самой библиотекой
  const [animationData, setAnimationData] = useState<unknown>(null);

  useEffect(() => {
    const loadAnimation = async () => {
      try {
        const res = await fetch(src);
        const json = await res.json();
        setAnimationData(json);
      } catch (error) {
        console.error(`Ошибка загрузки анимации ${src}:`, error);
      }
    };

    loadAnimation();
  }, [src]);

  if (!animationData) return null;

  return <Lottie animationData={animationData} loop autoplay className={className} />;
}
